import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton';
import GridBackground from '@/components/GridBackground';
import SEO from '@/components/SEO';
import NextSteps from '@/components/contact/NextSteps';
import ProjectContactForm from '@/components/contact/ProjectContactForm';
import useWhatsApp from '@/lib/useWhatsApp';
import { generalWaMessage } from '@/components/services/servicesData';

export default function Contact() {
  const { waLink } = useWhatsApp();
  return (
    <div className="relative min-h-screen bg-background overflow-hidden">
      <SEO
        fullTitle="Contact Jotunheims | Dubai Silicon Oasis, UAE"
        description="Contact Jotunheims FZCO in Dubai Silicon Oasis by WhatsApp, email or form. Tell us about your project and get a tailored plan."
        path="/contact"
      />
      <GridBackground />
      <Navbar />

      <main className="relative z-10 pt-36">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-inter font-bold tracking-tight text-foreground mb-4"
          >
            Talk to Our Dubai Team
          </motion.h1>
          <p className="text-muted-foreground font-inter mb-4">
            Jotunheims FZCO · Dubai Silicon Oasis, Dubai, United Arab Emirates · WhatsApp{' '}
            <a href={waLink(generalWaMessage)} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">+971 50 497 7224</a>
          </p>
          <p className="text-muted-foreground font-inter mb-4">
            Reach us at{' '}
            <a href="mailto:info@jotunheims.com" className="text-primary hover:underline">
              info@jotunheims.com
            </a>{' '}
            or send a message below.
          </p>
        </div>
        <NextSteps />
        <ProjectContactForm />
      </main>

      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}